@if (loginType) {
    <div
        class="login-layout"
        [class.login-layout--with-header]="hasHeader"
        [class.login-layout--with-footer]="hasFooter">
        @if (hasHeader) {
            <core-header-minimised></core-header-minimised>
        }
        <div
            class="login"
            [ngStyle]="pageBackgroundStyles"
            [class.login--custom-theme]="hasCustomTheme"
            [class.login--has-header]="hasHeader"
            [class.login--has-footer]="hasFooter">
            <h1 class="sr-only">{{ 'Login' | translate }}</h1>
            <div class="login__content">
                @if (!hasHeader) {
                    <core-brand-logo category="LOGIN"></core-brand-logo>
                }
                <div [ngClass]="cardContainerClasses" [ngStyle]="cardStyles">
                    @if (formImage) {
                        <div class="login__image-pane">
                            <img [ngSrc]="formImage" alt="" class="login__image" fill priority />
                        </div>
                    }
                    <div class="login__wrapper">
                        @if (titleText) {
                            <h2
                                class="login-card__title"
                                [innerHTML]="titleText"
                                [style.color]="cardStyles['--login-card-title-color']">
                                @if (!hasHeader) {
                                    <core-dark-mode-toggle [moonDark]="true" class="float-end"></core-dark-mode-toggle>
                                }
                            </h2>
                        }
                        @if (introHtml) {
                            <div
                                class="login__intro mb-3"
                                [innerHtml]="introHtml"
                                [style.color]="cardStyles['--login-card-intro-color']"
                                [style.font-size]="cardStyles['--login-card-intro-font-size']"></div>
                        }
                        @if (errorMessage) {
                            <div [innerHtml]="errorMessage" class="alert alert-danger"></div>
                        }
                        @if (successMessage) {
                            <div [innerHtml]="successMessage" class="alert alert-success"></div>
                        }

                        @if (loginBulletin?.text) {
                            <div class="login__bulletin">
                                <p [innerText]="loginBulletin?.text" class="login__bulletin-text"></p>
                                @if (loginBulletin?.linkHref && loginBulletin?.linkText) {
                                    <a
                                        [core-analytics]="{ action: 'Bulletin', category: 'LOGIN' }"
                                        [href]="loginBulletin?.linkHref"
                                        [innerText]="loginBulletin?.linkText"
                                        class="btn btn--outline-black btn--register mb-0"></a>
                                }
                            </div>
                        }

                        @switch (loginType) {
                            @default {
                                <form (ngSubmit)="login()" [formGroup]="loginForm">
                                    @if (loginType !== 'generic') {
                                        <div
                                            [ngClass]="{
                                                'form-group--success': loginForm.get('username')!.valid,
                                                'form-group--error':
                                                    loginForm.get('username')!.touched &&
                                                    !loginForm.get('username')!.valid,
                                            }"
                                            class="form-group">
                                            <div class="form-control-wrapper">
                                                <label
                                                    class="form-label"
                                                    for="email"
                                                    [style.color]="cardStyles['--login-card-label-color']"
                                                    >{{ 'Email address' | translate }}</label
                                                >
                                                <div class="form-control-wrapper">
                                                    <input
                                                        [attr.aria-describedby]="
                                                            loginForm.get('username')!.touched &&
                                                            !loginForm.get('username')!.valid
                                                                ? 'email-error'
                                                                : null
                                                        "
                                                        [attr.aria-invalid]="
                                                            loginForm.get('username')!.touched &&
                                                            !loginForm.get('username')!.valid
                                                        "
                                                        class="form-control form-control-lg"
                                                        formControlName="username"
                                                        id="email"
                                                        name="username"
                                                        type="email" />
                                                    <span
                                                        id="email-error"
                                                        [hidden]="
                                                            loginForm.get('username')!.untouched ||
                                                            loginForm.get('username')!.valid
                                                        "
                                                        aria-live="polite"
                                                        class="invalid-feedback form-control-feedback">
                                                        <span class="sr-only">{{ 'Incorrect' | translate }}</span>
                                                    </span>
                                                    <span
                                                        [hidden]="
                                                            loginForm.get('username')!.untouched ||
                                                            !loginForm.get('username')!.valid
                                                        "
                                                        aria-live="polite"
                                                        class="valid-feedback form-control-feedback">
                                                        <span class="sr-only">{{ 'Correct' | translate }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div
                                        [ngClass]="{
                                            'form-group--success': loginForm.get('password')!.valid,
                                            'form-group--error':
                                                loginForm.get('password')!.touched && !loginForm.get('password')!.valid,
                                        }"
                                        class="form-group">
                                        <label
                                            class="form-label"
                                            for="password"
                                            [style.color]="cardStyles['--login-card-label-color']"
                                            >{{ 'Password' | translate }}</label
                                        >
                                        <div class="form-control-wrapper form-control-wrapper--password">
                                            <input
                                                [attr.aria-describedby]="
                                                    loginForm.get('password')!.touched &&
                                                    !loginForm.get('password')!.valid
                                                        ? 'password-error'
                                                        : null
                                                "
                                                [attr.aria-invalid]="
                                                    loginForm.get('password')!.touched &&
                                                    !loginForm.get('password')!.valid
                                                "
                                                class="form-control form-control-lg"
                                                formControlName="password"
                                                id="password"
                                                name="password"
                                                type="{{ passwordType }}" />
                                            <span
                                                id="password-error"
                                                [hidden]="
                                                    loginForm.get('password')!.untouched ||
                                                    loginForm.get('password')!.valid
                                                "
                                                aria-live="polite"
                                                class="invalid-feedback form-control-feedback">
                                                <span class="sr-only">{{ 'Incorrect' | translate }}</span>
                                            </span>
                                            <span
                                                [hidden]="
                                                    loginForm.get('password')!.untouched ||
                                                    !loginForm.get('password')!.valid
                                                "
                                                aria-live="polite"
                                                class="valid-feedback form-control-feedback">
                                                <span class="sr-only">{{ 'Correct' | translate }}</span>
                                            </span>
                                        </div>
                                        <button
                                            (click)="togglePasswordType()"
                                            [core-analytics]="{ action: 'Toggle password type', category: 'LOGIN' }"
                                            [ngClass]="{ 'btn-show-active': passwordType === 'text' }"
                                            class="btn btn-show"
                                            tabindex="-1"
                                            type="button">
                                            {{ 'Toggle to show/hide password' | translate }}
                                        </button>
                                    </div>
                                    <div class="row no-gutters mb-3">
                                        <div class="col-12 p-0">
                                            <button
                                                [class.spinner]="loading"
                                                [core-analytics]="{ action: 'Login', category: 'LOGIN' }"
                                                [disabled]="
                                                    loading || (!disableButtonDisabledStyles && !loginForm.valid)
                                                "
                                                [style.color]="cardStyles['--login-card-button-text-color']"
                                                [style.border-radius]="cardStyles['--login-card-button-border-radius']"
                                                [style.text-align]="cardStyles['--login-button-text-align']"
                                                [ngClass]="loginButtonClasses"
                                                type="submit">
                                                @if (loading) {
                                                    <span
                                                        aria-hidden="true"
                                                        class="spinner-grow spinner-grow-sm"
                                                        role="status"></span>
                                                    <span class="visually-hidden">Logging in...</span>
                                                }
                                                <span [hidden]="loading">{{ 'Login' | translate }}</span>
                                            </button>
                                        </div>

                                        @if (loginType === 'individual' || loginType === 'mixed') {
                                            <div class="col-12 p-0 pt-2">
                                                <a
                                                    [core-analytics]="{ action: 'Reset password', category: 'LOGIN' }"
                                                    class="login-link"
                                                    routerLink="/reset">
                                                    {{ 'Reset password?' | translate }}
                                                </a>
                                            </div>
                                        }
                                    </div>
                                    @if (loginType !== 'generic') {
                                        <hr class="login-divider" />
                                        <div class="login__register-row">
                                            <p
                                                class="register-no-account"
                                                [style.color]="cardStyles['--login-card-intro-color']">
                                                {{ "Don't have an account?" | translate }}
                                            </p>
                                            <a
                                                [core-analytics]="{ action: 'Register', category: 'LOGIN' }"
                                                class="btn btn--outline-black btn--register mb-0"
                                                routerLink="/register"
                                                >{{ 'Create an account' | translate }}</a
                                            >
                                        </div>
                                        <!--              <a [core-analytics]="{action: 'Need help', category: 'LOGIN'}" class="login-link"-->
                                        <!--                 routerLink="/login-faqs"-->
                                        <!--              >{{ 'Need help?' | translate }}</a>-->
                                    }
                                </form>
                            }
                            @case ('generic-with-username') {
                                <form (ngSubmit)="login()" [formGroup]="loginForm">
                                    <div class="form-group">
                                        <label
                                            class="form-label"
                                            for="generic-username"
                                            [style.color]="cardStyles['--login-card-label-color']"
                                            >{{ 'Username' | translate }}</label
                                        >
                                        <div class="form-control-wrapper">
                                            <!-- Display-only field: the API flow authenticates with the password alone. -->
                                            <input
                                                autocomplete="username"
                                                class="form-control form-control-lg"
                                                id="generic-username"
                                                name="generic-username"
                                                type="text" />
                                        </div>
                                    </div>
                                    <div
                                        [ngClass]="{
                                            'form-group--success': loginForm.get('password')!.valid,
                                            'form-group--error':
                                                loginForm.get('password')!.touched && !loginForm.get('password')!.valid,
                                        }"
                                        class="form-group">
                                        <label
                                            class="form-label"
                                            for="generic-password"
                                            [style.color]="cardStyles['--login-card-label-color']"
                                            >{{ 'Password' | translate }}</label
                                        >
                                        <div class="form-control-wrapper form-control-wrapper--password">
                                            <input
                                                class="form-control form-control-lg"
                                                formControlName="password"
                                                id="generic-password"
                                                name="password"
                                                type="{{ passwordType }}" />
                                            <span
                                                [hidden]="
                                                    loginForm.get('password')!.untouched ||
                                                    loginForm.get('password')!.valid
                                                "
                                                aria-live="polite"
                                                class="invalid-feedback form-control-feedback">
                                                <span class="sr-only">{{ 'Incorrect' | translate }}</span>
                                            </span>
                                            <span
                                                [hidden]="!loginForm.get('password')!.valid"
                                                aria-live="polite"
                                                class="valid-feedback form-control-feedback">
                                                <span class="sr-only">{{ 'Correct' | translate }}</span>
                                            </span>
                                        </div>
                                        <button
                                            (click)="togglePasswordType()"
                                            [core-analytics]="{ action: 'Toggle password type', category: 'LOGIN' }"
                                            [ngClass]="{ 'btn-show-active': passwordType === 'text' }"
                                            class="btn btn-show"
                                            tabindex="-1"
                                            type="button">
                                            {{ 'Toggle to show/hide password' | translate }}
                                        </button>
                                    </div>
                                    <div class="row no-gutters mb-3">
                                        <div class="col-12 p-0">
                                            <button
                                                [class.spinner]="loading"
                                                [core-analytics]="{ action: 'Login', category: 'LOGIN' }"
                                                [disabled]="
                                                    loading || (!disableButtonDisabledStyles && !loginForm.valid)
                                                "
                                                [style.color]="cardStyles['--login-card-button-text-color']"
                                                [style.border-radius]="cardStyles['--login-card-button-border-radius']"
                                                [style.text-align]="cardStyles['--login-button-text-align']"
                                                [ngClass]="loginButtonClasses"
                                                type="submit">
                                                @if (loading) {
                                                    <span
                                                        aria-hidden="true"
                                                        class="spinner-grow spinner-grow-sm"
                                                        role="status"></span>
                                                    <span class="visually-hidden">Logging in...</span>
                                                }
                                                <span [hidden]="loading">{{ 'Login' | translate }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            }
                            @case ('individual-managed') {
                                @if (managedPage$ | async; as managedPage) {
                                    @if (managedPage) {
                                        <div class="row individual-managed">
                                            @for (
                                                block of managedPage.widgets | orderBy: ['data.row', 'data.col'];
                                                track trackByFn($index, block)
                                            ) {
                                                <core-block
                                                    [block]="block"
                                                    [class]="
                                                        getBlockClasses(block) +
                                                        ' ' +
                                                        getBlockClassPosition(block, managedPage.widgets[$index - 1])
                                                    "
                                                    [ngStyle]="{
                                                        padding: block.data.padding,
                                                        block: block.data.margin,
                                                    }">
                                                </core-block>
                                            }
                                        </div>
                                    }
                                } @else {
                                    <core-block-card-shimmer></core-block-card-shimmer>
                                }
                            }
                        }
                        @if (contactTitle) {
                            <div
                                class="login__contact-title mt-4"
                                [innerHtml]="contactTitle"
                                [style.color]="cardStyles['--login-card-contact-title-color']"
                                [style.font-size]="cardStyles['--login-card-contact-title-font-size']"></div>
                        }
                        @if (contactHtml) {
                            <div
                                class="login__contact-text mt-1"
                                [innerHtml]="contactHtml"
                                [style.color]="cardStyles['--login-card-contact-text-color'] || '#000000'"></div>
                        }
                    </div>
                </div>
                @if (!hasFooter) {
                    <core-login-footer></core-login-footer>
                }
            </div>
        </div>
        <core-demo-config-toggle></core-demo-config-toggle>
        @if (hasFooter) {
            <core-footer></core-footer>
        }
    </div>
}
